import React from 'react';
import './Link.css';
const Link = (props) => {
    return (React.createElement("a", { className: `custom-link ${props.className ?? ''}`, style: props.style, href: props.link, target: props.target ?? '_blank' },
        props.text,
        props.target === '_blank' && React.createElement("i", { className: "bi bi-box-arrow-up-right", style: { marginLeft: '10px' } })));
};
export default Link;
